import { paths } from "helpers/paths";
import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import HomeError from "./error";
import HomeHeaders from "./headers";
import Ip from "./ip";
import Ping from "./ping";

function Home(props: { location: any; token: string; roles: { [key: string]: boolean } }) {
    const { location } = props;
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route path={paths.error} component={HomeError} />
                {props.token && props.roles.isRoot ? (
                    <>
                        <Route path={paths.ip} component={Ip} />
                        <Route path={paths.headers} component={HomeHeaders} />
                        <Route path={paths.ping} component={Ping} />
                    </>
                ) : (
                    <Redirect to={paths.login} />
                )}
            </Switch>
        </div>
    );
}

const mapStateToProps = (state: { profile: { token: string; roles: { [key: string]: boolean } } }) => ({
    token: state.profile.token,
    roles: state.profile.roles,
});

export default connect(mapStateToProps, () => ({}))(Home);
